'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AuthorLink = require('./components/AuthorLink.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AuthorLink).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-author-link/lib/index.js
// module id = 1027
// module chunks = 1